import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import slugify from "underscore.string/slugify";
import forEach from "../../utils/forEach";
import {
  MenuOption,
  IconWrapper,
  Content,
  Dot,
  BetaBadge,
} from "./styles/sidebar-content-styles";
import cache from "../../../cache";

class Option extends Component {
  componentDidMount() {
    const icons = document.querySelectorAll(".sidebar-icon");
    const dropdowns = document.querySelectorAll(".dropdown-content");

    // menu items popovers
    forEach(icons, (item) => {
      item.addEventListener("mouseenter", () => {
        item.nextSibling.classList.add("show");

        forEach(dropdowns, (element) => {
          element.classList.remove("show");
        });
      });

      item.addEventListener("mouseleave", () => {
        item.nextSibling.classList.remove("show");
      });
    });
  }

  onClick() {
    // This is a hack to ensure that a new job appears in the jobs list page
    // after it gets created. Ideally we'd do this on job create, but that
    // currently lives in an erb file, so it's not possible.
    const { menuItem } = this.props;
    if (menuItem.label === "Add New Job") {
      cache.delete("job-list");
    }
  }

  render() {
    const { menuItem } = this.props;
    const { href, label, className, notification, icons, beta } = menuItem;

    return (
      <MenuOption
        data-turbolinks={false}
        href={href}
        onClick={() => this.onClick()}
        name={label}
        title={label}
        className={`${className || ""} ${slugify(label)}`}
      >
        <IconWrapper>
          {icons.map((icon) => (
            <Fragment key={icon.name}>
              <Icon
                name={icon.name}
                className={icon.className || "sidebar-icon"}
              />
            </Fragment>
          ))}
          <Content>{label}</Content>
          <Dot
            className={`${slugify(label)}-dot ${!notification ? "hidden" : ""}`}
          />
          {beta && <BetaBadge>beta</BetaBadge>}
        </IconWrapper>
      </MenuOption>
    );
  }
}

Option.propTypes = {
  menuItem: PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    notification: PropTypes.bool,
    icons: PropTypes.arrayOf(
      PropTypes.shape({ name: PropTypes.string, className: PropTypes.string })
    ),
    beta: PropTypes.bool,
  }).isRequired,
};

export default Option;
